// extracted by mini-css-extract-plugin
module.exports = {"main":"contentTwoColumn_main__Jba7c","left":"contentTwoColumn_left__3KZ3L","right":"contentTwoColumn_right__kKkVp"};